import { render, staticRenderFns } from "./SinglePostPageInfo.vue?vue&type=template&id=fca89f72&scoped=true"
import script from "./SinglePostPageInfo.vue?vue&type=script&lang=js"
export * from "./SinglePostPageInfo.vue?vue&type=script&lang=js"
import style0 from "./SinglePostPageInfo.vue?vue&type=style&index=0&id=fca89f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca89f72",
  null
  
)

export default component.exports